import React from 'react';
import ProjectInterface from './ProjectInterface'





export default class Newimage extends React.Component<ProjectInterface, {}> {
  
  
  constructor(props: ProjectInterface) {
    super(props);
  }


  render() {
    return (
    <a href={this.props.link}>
      <div className="Newimage">
        <p style={{ textAlign: 'left', position: "absolute", top: "12px", left: "30px" }}>{this.props.name}</p>
        <img src={this.props.addrImage} alt="Imageduprojet"/>
        <p style={{ position: "absolute", marginLeft: "60%", bottom: "0px" }}>{this.props.date}</p>
        <div className="lds-ripple"><div></div><div></div></div>
      </div>
    </a>
  );
}


}